import { MediaContentType } from "../../../models";
import { FormsT } from "../form/FormTypes";

export const MediaFields: FormsT[] = [
    {
        type: "enumSelect",
        title: "Content type",
        property: "contentType",
        enumType: MediaContentType,
        helpMsg: "Type of content",
    },
    {
        type: "date",
        title: "Date created",
        property: "dateCreated",
        helpMsg: "Date created",
    },
    {
        type: "textInput",
        title: "File name",
        property: "name",
        placeholder: "Enter file name",
        helpMsg: "File name",
    },
    {
        type: "textInput",
        title: "Description",
        property: "description",
        placeholder: "Enter description",
        helpMsg: "Description of content",
    },
    {
        type: "textInput",
        title: "Attribution",
        property: "attribution",
        placeholder: "Enter attribution",
        helpMsg: "Attribution information",
    },
    {
        type: "textInput",
        title: "Attribution link",
        property: "attributionLink",
        placeholder: "Enter attribution link",
        helpMsg: "Link to source attribution information or license",
    },
    {
        type: "textInput",
        title: "Attribution user id",
        property: "contributorId",
        placeholder: "Enter user uuid",
        helpMsg: "User id for the creator",
    },

    {
        type: "date",
        title: "Date added",
        property: "dateAdded",
        helpMsg: "Date added",
    },
];
